import type { FaireProductEntity } from "../../entity_types/product";

export const p_4yx7dmzsp5: FaireProductEntity = {
  token: "p_4yx7dmzsp5",
  type: "product",
  name: "Warlord Japanese Washi Stickers JP",
  brandToken: "b_m8c3mbnsfa",
  brandName: "Urban Tokyo",
  imageUrl: "https://cdn.faire.com/fastly/be3499fb99f33c166456117cba3ec8bf6925f40cd413a926cd3e7a037dcc4cd7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/34ec08e62c918498e539dd01f2dfc466f10aa33cfeb0e24eca3fc4712131ab47.jpeg",
    "https://cdn.faire.com/fastly/e189dfd1a86af74edbb4fdf46645f4cf901f3fd10609f7a0b8cd2b1751a64ed0.jpeg"
  ],
  priceDollars: 2,
  description: "Add a touch of Japan to cards, gift wrap and journals with these Warlord washi stickers. Made in Japan, they make an easy add-on for gift shops and checkout counters, and a fun souvenir for fans of Japanese design.\n\nFeatures\n\n * Japanese washi stickers: a classic Japanese craft item for scrapbooks, planners, letters and gift wrap \n * Collect the series: also available in Sakura, Origami, O-Gi Fan, Maneki Neko, Japanese Foods, Origami Cranes, Ukiyo Mt. Fuji \nSpecifications\n\n * Type: Washi stickers \n * Design: Warlord \n * Inner pack: 1 \n * Case pack: 100 \n * Origin: Japan ",
  tags: [],
  msrpDollars: 4.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:54.862Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
